import axios from 'axios';

export const state = {
}

export const getters = {}

export const mutations = {
}

export const actions = {

  async fetchOrders({ commit, dispatch, getters }, pagination = {}) {

    const { page, rowsPerPage, sortBy, descending } = pagination;

    const result = await axios.post('orders/list',
      {
        where: null,
        search: null,
        strict: true,
        pagination: {
          page,
          rowsPerPage,
          sortBy,
          descending
        }
      });

    return result.data;
  },

  async fetchSuccessOrders({ commit, dispatch, getters }, pagination = {}) {

    const { page, rowsPerPage, sortBy, descending } = pagination;

    const result = await axios.post('orders/list',
      {
        where: {
          column: "status",
          value: "COMPLETE"
        },
        search: null,
        strict: true,
        pagination: {
          page,
          rowsPerPage,
          sortBy,
          descending
        }
      });

    return result.data;
  },

  async fetchPendingOrders({ commit, dispatch, getters }, pagination = {}) {

    const { page, rowsPerPage, sortBy, descending } = pagination;

    const result = await axios.post('orders/list',
      {
        where: {
          column: "status",
          value: "PENDING"
        },
        search: null,
        strict: true,
        pagination: {
          page,
          rowsPerPage,
          sortBy,
          descending
        }
      });

    return result.data;
  },

  async fetchFailedOrders({ commit, dispatch, getters }, pagination = {}) {

    const { page, rowsPerPage, sortBy, descending } = pagination;

    const result = await axios.post('orders/list',
      {
        where: {
          column: "status",
          value: "FAILED"
        },
        search: null,
        strict: true,
        pagination: {
          page,
          rowsPerPage,
          sortBy,
          descending
        }
      });

    return result.data;
  },

  async dashboardUsers({ commit, dispatch, getters }, pagination = {}) {

    const result = await axios.post('company/list',
      {
        where: null,
        search: null,
        strict: true,
        role: null,
        pagination: {
          page: 1,
          rowsPerPage: 4,
          sortBy: "id",
          descending: true
        }
      });

    return result.data;
  },

  async orderStatus({ commit, dispatch, getters }, orderRefId = {}) {

    const result = await axios.get('orders/status/'+orderRefId);

    return result.data;
  },

}
